import { useEffect, useRef } from 'react';

export default function useCloseElOnOutsideClick({
  closeFn,
  isOpen,
  toggleEl,
}: {
  closeFn: () => void;
  isOpen: boolean;
  toggleEl?: HTMLElement;
}) {
  const ref = useRef<null | HTMLDivElement>();

  const handleClickOutside = (e: MouseEvent | TouchEvent) => {
    const isToggleEl = toggleEl?.contains(e.target as Node);
    const isOutsideClick = !ref?.current?.contains(e.target as Node);
    if (isOpen && isOutsideClick && !isToggleEl) {
      closeFn();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  });

  return { ref };
}
